import React from 'react';

const Footer = () => {
  return (
    <footer className='min-w-full bg-neutral-500 p-4'>
        <p className='text-center'>Created by Braden McCoy &copy; 2024</p>
    </footer>
  );
};

export default Footer;
